<template>
  <v-card :class="resultsMobile ? 'mx-0' : 'mx-3'">
    <v-toolbar color="grey lighten-2" elevation="0">
      <v-icon class="mr-3">mdi-text-box-outline</v-icon>
      <v-toolbar-title class="subtitle-1 font-weight-bold">
        <span
          v-html="
            resultadoBusca.length ? 'Resultado' : 'Nenhuma busca realizada'
          "
        />
        <div class="caption">
          {{ totalRegistros }} resultados em {{ tempoExecucao / 1000 }} segundos
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-tooltip bottom>
        <template #activator="{ on }">
          <v-btn
            icon
            v-on="on"
            :disabled="resultadoBusca.length ? false : true"
          >
            <v-icon large color="primary">mdi-pdf-box</v-icon>
          </v-btn>
        </template>
        <span>Exportar consulta para .PDF</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-btn
            icon
            v-on="on"
            :disabled="resultadoBusca.length ? false : true"
          >
            <v-icon large color="primary">mdi-microsoft-excel</v-icon>
          </v-btn>
        </template>
        <span>Exportar consulta para .XLS</span>
      </v-tooltip> -->
    </v-toolbar>
    <v-progress-linear
      :indeterminate="loading"
      :active="loading"
      color="primary"
    ></v-progress-linear>
    <v-card
      class="pa-0 mx-0 overflow-y-auto"
      elevation="0"
      :height="resultsMobile ? height : innerHeight - 340 + 'px'"
    >
      <listagem-documentos
        :listaDocumentos="resultadoBusca"
        :novaBusca="novaBusca"
        :isMobile="true"
        @paginar="paginar"
      />
    </v-card>
  </v-card>
</template>
<script>
import ListagemDocumentos from "@/shared/ListagemDocumentos";
export default {
  props: {
    resultadoBusca: { type: Array },
    loading: { type: Boolean },
    resultsMobile: { type: Boolean, default: false },
    termo: { type: String },
    novaBusca: { type: Boolean },
    totalRegistros: { type: Number },
    tempoExecucao: { type: Number },
    isMobile: { type: Boolean, default: false }
  },
  components: {
    ListagemDocumentos
  },
  data() {
    return {
      innerHeight: window.innerHeight,
      height: window.innerHeight - 112 + "px"
    };
  },
  watch: {
    resultadoBusca: {
      handler() {
        if (this.resultadoBusca) {
          this.resultadoBusca.map(documento => {
            documento.tituloFormatado = documento._source.tipo;
            let doc = "";
            documento.highlight.descricao.map(descricao => {
              doc += descricao.replace("\n\n", "");
            });
            documento.descricaoFormatada = doc;
            documento.tituloFormatado = this.getTitulo(documento._source);
          });
        }
      }
    }
  },
  methods: {
    paginar($state) {
      this.$emit("paginar", $state);
    },
    getTitulo(documento) {
      // let documento = doc._source;
      switch (documento.tipo) {
        case "INFORMAÇÃO":
          if (!documento.numero && documento.ano) {
            return (
              documento.tipo +
              " " +
              documento.ano +
              " - " +
              documento.relator +
              " e-Doc " +
              documento.edoc
            );
          } else if (documento.numero && !documento.ano) {
            return (
              documento.tipo +
              " " +
              documento.numero +
              " - " +
              documento.relator +
              " e-Doc " +
              documento.edoc
            );
          } else if (documento.ano && documento.numero) {
            return (
              documento.tipo +
              " " +
              documento.numero +
              "/" +
              documento.ano +
              " - " +
              documento.relator +
              " e-Doc " +
              documento.edoc
            );
          } else {
            return (
              documento.tipo +
              " - " +
              documento.relator +
              " e-Doc " +
              documento.edoc
            );
          }
        case "DECISÃO":
          return (
            documento.tipo +
            " " +
            documento.numero +
            "/" +
            documento.ano +
            " - Sessão " +
            documento.tipo_sessao +
            " " +
            documento.numero_sessao +
            " do dia " +
            documento.data_sessao +
            " e-Doc " +
            documento.edoc
          );
        case "RELATÓRIO / VOTO":
          return (
            documento.tipo +
            " - " +
            documento.relator +
            " - Sessão " +
            documento.tipo_sessao +
            " " +
            documento.numero_sessao +
            " do dia " +
            documento.data_sessao +
            " e-Doc " +
            documento.edoc
          );
        case "PARECER":
          return (
            documento.tipo +
            " - " +
            documento.relator +
            " " +
            documento.data_sessao +
            " e-Doc " +
            documento.edoc
          );
        case "ATA DE SESSÃO":
          return (
            "ATA DA SESSÃO " +
            documento.tipo_sessao +
            " " +
            documento.numero_sessao +
            " do dia " +
            documento.data_sessao +
            " e-Doc " +
            documento.edoc
          );
        case "JURISPRUDÊNCIA SELECIONADA":
          return (
            documento.tipo +
            " - " +
            documento.assunto_documento +
            " - " +
            documento.numero +
            "/" +
            documento.ano +
            " e-Doc " +
            documento.edoc
          );
        case "ACÓRDÃO":
          if (!documento.numero) {
            return documento.tipo + " - Sessão do dia " + documento.data_sessao;
          } else {
            return (
              documento.tipo +
              " nº " +
              documento.numero +
              " - Sessão do dia " +
              documento.data_sessao +
              " e-Doc " +
              documento.edoc
            );
          }
        default:
          return (
            documento.tipo +
            " - " +
            documento.data_sessao +
            " e-Doc " +
            documento.edoc
          );
      }
    }
  }
};
</script>
